import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import PlayerInfoTabs from './PlayerInfoTabs';
window.mountPlayerInfoTabs = function mountPlayerInfoTabs(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('PlayerInfoTabs: container not found:', containerId);
        return { unmount: () => { }, get api() { return null; } };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(PlayerInfoTabs, { ...props, ref: apiRef }));
    return {
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
